<div>
  Каждая 5-я строка — «подытог»: жирный шрифт задаётся инлайново через
  <code>bodyRowCfg.styleCfg.style</code> (объект <code>StyleBuilder.Row</code>), а класс
  <code>not-hover</code> (через <code>bodyRowCfg.styleCfg.class</code>) отключает ховер.
</div>

<aur-mat-table
  class="limit-size"
  [tableData]="tableData"
  [tableConfig]="tableConfig"
></aur-mat-table>
